import { chakra, shouldForwardProp } from '@chakra-ui/react';
import layoutStore from '../stores/layoutStore';
import WorkspacesGrid from './WorkspacesGrid';
import { motion, isValidMotionProp, AnimatePresence } from 'framer-motion';

const WsWrapper = ({ children }) => {
    const hoverSide = layoutStore((state) => state.hoverSide);
    const workspaceZoom = layoutStore((state) => state.workspaceZoom);

    // const getAnimationProps = () => {
    //     let x = 0,
    //         scale = 1,
    //         borderRadius = '16px 0 0 16px',
    //         originX = 0.5;
    //     //filter = 'var(--chakra-colors-wsPlateShadow)';

    //     /* if (workspaceZoom === 'zoomed-out') {
    //         scale = 0.25;
    //         borderRadius = '36px';
    //         filter = wsShadow;
    //     } */

    //     if (workspaceZoom === 'zoomed-in') {
    //         scale = 1;
    //     }

    //     if (hoverSide && workspaceZoom === 'zoomed-in') {
    //         x = 16;
    //         scale = 1; //0.9625;
    //         //borderRadius = '16px';
    //         //@ts-ignore
    //         originX = 0;
    //         //filter = wsShadow;
    //     }

    //     return { x, scale, borderRadius, originX };
    // };

    /* if (workspaceZoom === 'zoomed-out') {
        return <WorkspacesGrid />;
    } */

    return (
        <AnimatePresence mode="sync" initial={false}>
            {workspaceZoom === 'zoomed-out' ? (
                <motion.div
                    initial={{ scale: 1.125 }}
                    animate={{ scale: 1 }}
                    exit={{ scale: 1.125 }}
                >
                    <WorkspacesGrid />
                </motion.div>
            ) : (
                <ChakraBox
                    as={motion.div}
                    layoutId={'workspace-container'}
                    initial={{
                        x: 0,
                        scale: 0.9475,
                        borderRadius: '16px 16px 16px 16px'
                        //originX: layoutStore.getState().zoomXY?.x || 0.5,
                        //originY: layoutStore.getState().zoomXY?.y || 0.5
                    }}
                    animate={{
                        //...getAnimationProps(),
                        x: hoverSide ? 16 : 0,
                        scale: 1,
                        borderRadius: '16px 0px 0px 16px',
                        transition: { delay: 0.04 /* duration: 0.32 */ }
                    }}
                    exit={{ scale: 0 }}
                    //@ts-ignore
                    //transition={{
                    //scale: { duration: 0.32, type: 'spring', bounce: 0.18 }
                    //layout: { duration: 0.32, type: 'spring', bounce: 0.18 }
                    //}}
                    //rounded={'16px 0 0 16px'}
                    flex={1}
                    p="0"
                    bg="te1"
                    display="flex"
                    flexDir={'column'}
                    style={{
                        filter: 'var(--chakra-colors-wsPlateShadow)'
                        //overflowX: 'auto'
                        //transformOrigin: 'left center'
                    }}
                >
                    {children}
                </ChakraBox>
            )}
        </AnimatePresence>
    );
};
const ChakraBox = chakra(motion.div, {
    shouldForwardProp: (prop) =>
        isValidMotionProp(prop) || shouldForwardProp(prop)
});

export default WsWrapper;
